module.exports = __webpack_public_path__ + "static/media/university-open-days.8ca31bdd.jpg";